import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {WarriorPayfeatureView} from "./WarriorPayfeatureView";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {WGGameConfig} from "../../../WGGameConfig";


export class WarriorPayFeature extends Presentation {

    private _triggerWarriorSymbol: string = "";
    private _nudgeStepsonReel: number[] = [0, 0, 0, 0, 0, 0];
    public static _nudgeSteps: number[];
    private _activeWarriorSymbolReel: boolean[];
    private _lastnudgingReel: number = 0;
    private _nudgesoundX1reels: number[] = [];
    private _finalMultiplier: number = 0;
    private _view: WarriorPayfeatureView;
    private _nextMode: string = "";
    private _reels: string[][] = [];

    constructor() {
        super();
        this._view = this.addChild(new WarriorPayfeatureView());
    }

    /**
     * overrride this function to start this presentation
     * when server sends symbol name triggerWarriorSymbol
     * @param data
     */
    public checkForActivation(data: WGParsedGameData): boolean {
        return data.triggerWarriorPay;
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._view._triggeredWarriorSymbol = this._triggerWarriorSymbol = data.triggerWarriorSymbol;
        super.setParsedGamedData && super.setParsedGamedData(data);
        this._activeWarriorSymbolReel = data.activeWarriorSymbolReel;
        this._view._activeWarriorReels = data.activeWarriorSymbolReel;
        // using this tag to identify if there is wil present on that reel, so M symbols would not move there.
        this._view.wildMultipliers = data.wildMultipliers;
        this._reels = data.actualReels;
        this._finalMultiplier = data.warriorMultiplier;
        this._view._isSoundAborted = false;
        this._view._movementPresent = false;
        this._view._stickyWildReels = data.lockedWildReelsAfter;
        this._view._warriorMultiplieronSymbols = [1, 1, 1, 1, 1, 1];
        this._nudgeStepsonReel = this.calculateNudgeStepsOnReels(data.actualReels);
        this._nudgesoundX1reels = [];
        for (let i: number = 0; i < data.actualReels.length; i++) {
            if (data.activeWarriorSymbolReel[i] && this._nudgeStepsonReel[i] === 0) {
                this._nudgesoundX1reels.push(i);
            }
        }
    }

    /**
     * function to calculate nudge steps and -ve if in opposite direction
     * @param reels
     */
    private calculateNudgeStepsOnReels(reels: string[][]): number[] {
        const symName = this._triggerWarriorSymbol + "*" + "1";
        for (let i: number = 0; i < reels.length; i++) {
            if (this._view._stickyWildReels[i]) {
                continue;
            }
            for (let j: number = 0; j < reels[i].length; j++) {
                if (reels[i][j].indexOf(symName) > -1) {
                    // assuming 2 is the base for i to get middle piece of stack symbol in center i.e. poistion 2;
                    this._nudgeStepsonReel[i] = (2 - j);
                }
            }
        }
        WarriorPayFeature._nudgeSteps = this._nudgeStepsonReel;
        this.findLastNudgingReelId();
        return this._nudgeStepsonReel;
    }

    /**
     * function to find last nudging reel id
     * reelId with greter number of steps will be last nudging reeel id.
     */
    private findLastNudgingReelId(): void {
        this._lastnudgingReel = 0;
        this._nudgeStepsonReel.forEach((value: number, index: number) => {
            if (Math.abs(value) > 0) {
                this._lastnudgingReel = index;
            }
        });
    }

    public getPresentation(): void {
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        let reelsToShowWinBoxes: number[] = [];
        for (let i: number = 0; i < WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT; i++) {
                this.DimAllSymbols(i);
            if (this._activeWarriorSymbolReel[i]) {
                reelsToShowWinBoxes.push(i);
            }
        }
        this._view.createMSymbolAliveAnimation(); // creating all the assets
        // to show overlays on reel
        for (let i: number = 0; i < this._activeWarriorSymbolReel.length; i++) {
            if (this._activeWarriorSymbolReel[i]) {
                this._view.showOverlayOfStackSymbolAnimationBeforeNudge(i, this._triggerWarriorSymbol, this._nudgeStepsonReel[i]);
            }
        }
        // nudging of overlays
        for (let i: number = 0; i < this._nudgeStepsonReel.length; i++) {
            if (this._nudgeStepsonReel[i] !== 0) {
                this.pTimeline.add(this._view.nudgeAliveSymbol(this._nudgeStepsonReel[i], i));
            }
            if (this._nudgeStepsonReel[i] == 0 && this._activeWarriorSymbolReel[i]) {
                this.pTimeline.add(() => this._view.nudgeStepCompleted(i, true));
                this.pTimeline.add(() => {
                    if (!this._view._isSoundAborted && !this._nudgesoundX1reels.includes(i + 1)) { // to fix #271
                        SoundManager.playSoundEffect(WGSoundConfig.instance.WILD_NO_NUDGE);
                    }
                });
                this.pTimeline.to({},0.2,{});

            }
        }
        // playing alive animtion of that ovelays
        const time = this.pTimeline.totalDuration() + 0.2;
        for (let i: number = 0; i < this._activeWarriorSymbolReel.length; i++) {
            if (this._activeWarriorSymbolReel[i]) {
                    if (this._activeWarriorSymbolReel.indexOf(true) === i) {
                    this.pTimeline.add(() => {
                        SoundManager.playSoundEffect(WGSoundConfig.instance.WARRIOR_ALIVE_SWEEP);
                    }, time);
                }
                this.pTimeline.add(this._view.playMSymbolAliveAnimation(i, this._triggerWarriorSymbol, this._nudgeStepsonReel[i]), time);
            }
        }
        // moving multiplier animaiton and overlay to desired reels
        this.pTimeline.add(this._view.moveMSymbolsToDesiredPositions(this._triggerWarriorSymbol));
        // just ot make sure ther is not fire on reel when warriror attack finishes off.
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    /**
     * function to  dim all symbols before feature starts.
     */
    private DimAllSymbols(reel: number): void {
        // to undim wild when warrior attack
        if (this._view._stickyWildReels[reel] || this._view.wildMultipliers[reel]) {
            for (let j: number = 0; j < WGEngineManager.getReel(reel).windowAmount; j++) {
                let symPos: number = WGEngineManager.getReel(reel).AllWindowSymbols[j].posID + WGEngineManager.getReel(reel).statePosOffset;
                WGEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0, 0.1);
            }
            WGEngineManager.getReel(reel).undimWildsOverlay();
        } else {
            for (let j: number = 0; j < WGEngineManager.getReel(reel).windowAmount; j++) {
                let symPos: number = WGEngineManager.getReel(reel).AllWindowSymbols[j].posID + WGEngineManager.getReel(reel).statePosOffset;
                WGEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0.6, 0.1);
            }
            WGEngineManager.getReel(reel).scatterSymbols.forEach((s) => s.attentionDarkness(0.6, 0.1));
        }
    }


    public skipPresentation(): void {
        this._view._isSoundAborted = true;
        this._view._deadToAliveTransition.forEach(value => {
            value.alpha = 0;
        });
        this.pTimeline.totalProgress(1);
        this._view.tlCount.totalProgress(1);
    }

    /**
     * clearing variables on presentation stop
     */
    public stopPresentation(): void {
        this._nudgeStepsonReel = [0, 0, 0, 0, 0, 0];
        this._lastnudgingReel = 0;
        this._view._warriorMulitplierGlow.forEach(value => value.visible = false);
        this._activeWarriorSymbolReel = [false, false, false, false, false, false];
        this._view._activeWarriorReels = [false, false, false, false, false, false];
    }
}